export const textAbbreviation = (text: string, num: number, ) => {
    return `${text.slice(0, num)} ...`;
};